import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../../firebase";
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
} from "firebase/auth";
import logo from "../../assets/logo/logo.jpeg";
import loginImg from "../../assets/images/login-img.jpg";

export default function Login() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState("");
  const [resetMsg, setResetMsg] = useState("");

  const handleLogin = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setError("");
    setResetMsg("");

    try {
      const userCredential = await signInWithEmailAndPassword(
        auth,
        email,
        password
      );
      const token = await userCredential.user.getIdToken();

      if (rememberMe) {
        localStorage.setItem("authToken", token);
      } else {
        sessionStorage.setItem("authToken", token);
      }

      navigate("/dashboard");
    } catch (err: any) {
      setError("Wrong email or password. Please try again.");
    }
  };

  return (
    <div>
      <div className="flex justify-between">
        <div className="flex justify-center items-center w-1/2">
          <form onSubmit={handleLogin} className="flex flex-col">
            <div className="flex justify-center lg:justify-start items-center gap-4 mb-8">
              <img src={logo} alt="Logo" className="w-20 h-20" />
            </div>

            <div className="mb-4 lg:mb-20 text-center lg:text-left">
              <h2 className="text-2xl lg:text-5xl font-extrabold">
                Hi, Welcome Back
              </h2>
              <p className="text-sm lg:text-base text-gray-600">
                Enter your email and password to access your account.
              </p>
            </div>

            {error && (
              <p className="text-sm lg:text-base text-red-500 mb-2">{error}</p>
            )}
            {resetMsg && (
              <p className="text-sm lg:text-base text-green-600 mb-2">
                {resetMsg}
              </p>
            )}

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email"
              className="w-full p-2 border border-gray-600 mb-4 rounded-md focus:outline-2 focus:border-0 outline-blue-600"
              required
            />

            <div className="relative w-full mb-4">
              <input
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="Password"
                className="w-full p-2 border border-gray-600 rounded-md focus:outline-2 focus:border-0 outline-blue-600"
                required
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-2 top-3 text-sm text-blue-600"
              >
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>

            <div className="flex items-center justify-end mb-5 lg:mb-10 text-sm">
              {/* <label className="flex items-center space-x-1 cursor-pointer">
								<input
									type="checkbox"
									checked={rememberMe}
									onChange={(e) => setRememberMe(e.target.checked)}
									className="accent-blue-600"
								/>
								<span>Remember Me</span>
							</label> */}

              <button
                type="button"
                onClick={() => navigate("/reset-password")}
                className="text-gray-600 hover:underline cursor-pointer"
              >
                Forgot Password?
              </button>
            </div>

            <button
              type="submit"
              className="w-full lg:w-1/2 bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 cursor-pointer"
            >
              Sign In
            </button>
          </form>
        </div>
        <div className="w-1/2">
          <img
            src={loginImg}
            alt="login img"
            className="w-full h-screen object-cover"
          />
        </div>
      </div>
    </div>
  );
}
